<template>
<div class="album">
    <div class="tabs">
        <div class="scroll-content">
            <div class="tab" :class="{'active': active === index}"
                v-for="(item, index) in tabs"
                :key="`tab-${index}`"
                @click="handleChangeTab(index)">
                <div class="tab-text">{{ item }}</div>
            </div>
        </div>
    </div>
    <div class="image-scroll">
        <div class="image-wrapper">
            <img class="image"
                 v-for="(item, index) in displayImages"
                 :key="item.id"
                 @click="handlePreview(index)"
                 v-lazy="item.image" />
        </div>
    </div>
</div>
</template>

<script>
import { ImagePreview } from 'vant'
import 'vant/lib/image-preview/style'

export default {
    data () {
        return {
            active: 0,
            tabs: [],
            images: [],
            previewImages: [],
            displayImages: []
        }
    },
    created () {
        this.tabs = [this.$t('home.all')].concat(this.$store.state.album.imageFolders)
        this.images = this.$store.state.album.previewImages.slice(0)
        this.displayImages = this.$store.state.album.previewImages.slice(0)
    },
    methods: {
        generateObj (src) {
            return {
                src,
                error: '/image/default_img.jpg',
                loading: '/image/loading-img.jpg'
            }
        },
        // 修改tab
        handleChangeTab(index) {
            let displayImages = []
            if (index === 0) {
                displayImages = this.images
            } else {
                displayImages = this.images.filter(item => {
                    return item.folder === this.tabs[index]
                })
            }
            this.active = index
            this.displayImages = displayImages
        },
        // 预览图片
        handlePreview(index) {
            ImagePreview({
                images: this.displayImages.map(item => item.image),
                startPosition: index,
                closeable: true,
                'close-icon-position': 'top-right'
            })
        }
    }
}
</script>

<style lang="scss" scoped>
/* pages/exploreAround/album/index.wxss */
.album {
	padding-bottom: 40px;
}
.tabs {
  width: 100%;
  overflow: auto;
  white-space: nowrap;
  text-align: justify;
  font-size: 16px;
}

.scroll-content {
  display: flex;
  align-items: center;
}

.tabs .tab {
  padding: 10px 12px 13px;
  font-size: 16px;
  color: #888888;
  position: relative;
  transition: all 0.2s ease-out;
}

.tab-text {
  position: relative;
  z-index: 1;
}

.tabs .tab:after {
  content: '';
  width: 32px;
  height: 3px;
  background-color: #f8a909;
  position: absolute;
  bottom: 13px;
  margin-top: 2px;
  left: 50%;
  margin-left: -16px;
  transform: scale(0);
  transition: transform 0.2s ease-out;
  z-index: 0;
}

.tabs .tab.active .tab-text {
  font-weight: bold;
  font-family: "Montserrat";
  color: #222125;
}

.tabs .tab.active:after {
  transform: scale(1);
}

.image-scroll {
  height: calc(100vh - 46px);
  overflow: auto;
}

.image-wrapper {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
}

.image-wrapper .image {
  width: calc(50vw - 4px);
  height: 160px;
  display: block;
  margin-top: 7px;
}
</style>